import React from 'react';
import PropTypes from 'prop-types';

const Heading = function Heading(props) {
    const { children, small, issuccessmessage } = props;
    return (
        <h1
            className={small ? 'is-size-4' : 'is-size-3'}
            style={issuccessmessage ? { color: '#229D4A' } : null}
            name={issuccessmessage ? 'successmessage' : ''}
        >
            {children}
        </h1>
    );
};

Heading.propTypes = {
    children: PropTypes.node.isRequired,
    small: PropTypes.bool,
    issuccessmessage: PropTypes.bool,
};

Heading.defaultProps = {
    small: false,
    issuccessmessage: false,
};

export default Heading;
